export const tooltipMixin = {
  methods: {
    getRangeTooltip(billing_type, isLegacy) {
      if (billing_type == 1) {
        return (
          'O valor a ser cobrado será a <b>multiplicação entre a quantidade consumida e o valor de cada faixa atingida</b>, ' +
          'somando os resultados de cada faixa. <br>Caso o consumo exceda a ultima faixa, a quantidade excedente continuará sendo multiplicada pela valor da ultima faixa.'
        );
      }

      if (billing_type == 2) {
        return 'O valor a ser cobrado será a multiplicação entre a quantidade consumida e o valor da última faixa atingida.';
      }

      if (billing_type == 3) {
        return (
          'O valor a ser cobrado será o valor integral da faixa atingida pela quantidade de consumo do cliente. ' +
          '<br>Caso o consumo exceda a ultima faixa, será cobrado o valor unitário resultado da divisão da quantidade da ultima faixa pelo seu valor.'
        );
      }

      if (billing_type == 4) {
        if (isLegacy) {
          return 'NÃO UTILIZADO EM CONTRATO LEGADO';
        }
        return (
          'Cobra um determinado valor fixo conforme a quatidade consumida. Cada faixa deve conter uma quantidade limite e um valor definido para esse limite. ' +
          '<br>Caso o consumo exceda a ultima faixa cadastrada, será cobrado um valor extra por unidade.'
        );
      }
    },
  },
};
